import { createContext } from "react";

export interface ProjectTableSelectionValue {
  onToggleSelect: (id: number) => void;
  selectedProjectIds: Set<number>;
}

/**
 * Lets the "select" column's checkbox cell read selection state without being a dependency of
 * createProjectTableColumns() — selectedProjectIds is a new Set on every toggle, and having the
 * column-def closure depend on it forced TanStack to rebuild the whole columns array (and
 * recompute its column/row model) on every single checkbox click.
 */
export const ProjectTableSelectionContext = createContext<ProjectTableSelectionValue>({
  onToggleSelect: () => {},
  selectedProjectIds: new Set(),
});
